import React, { useEffect } from "react";
import Select from "react-select";
import { getAllRadiologyReport } from "../../../../../store/slices/radiologyReport";
import { useDispatch, useSelector } from "react-redux";
import styles from "../scss/editRadiologyReport.module.scss";
import classNames from "classnames";
import { getAllClinic } from "../../../../../store/slices/clinicSlice";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const ServiceDetails = ({
  handleAddDescription,
  radiologyReportFormData,
  handleTestProfileChange,
  selectAllOutsource,
  setSelectAllOutsource,
  handleChange,
}) => {
  const dispatch = useDispatch();
  const { allClinicLists, clinicInfo } = useSelector((state) => state.clinic);
  const { radiologyReports } = useSelector((state) => state.radiologyReport);
  const radiologyReportId = sessionStorage.getItem("radiologyReportId");
  const { token } = useSelector((state) => state.auth);
  const newRadiologyReports = radiologyReports[0];
  const clinicId =clinicInfo?.[0]?.clinicId || null;

  useEffect(() => {
    dispatch(
      getAllRadiologyReport({
        clinicId,
        reportId: radiologyReportId,
        token,
      }),
    );
    dispatch(getAllClinic({ token }));
  }, [dispatch, clinicId, radiologyReportId, token]);

  const sourceType = [
    { value: "inHouse", label: "In House" },
    { value: "outSource", label: "Out Source" },
  ];

  const testDataMap = radiologyReportFormData?.serviceDetails?.reduce(
    (acc, test) => {
      if (test?.id) {
        acc[test.id] = test;
      }
      return acc;
    },
    {},
  );

  const handleSourceTypeChange = (e, serviceId, value) => {
    handleTestProfileChange(e, "sourceType", serviceId);
    if (value === "inHouse" && selectAllOutsource) {
      setSelectAllOutsource(false);
    }
  };

  return (
    <div className={classNames(styles.testAndProfile, "card")}>
      <div className="card-body pt-0">
        <h3 className="mt-4 text-center text-primary">
          {newRadiologyReports?.radiologyServiceInfo?.serviceName}
        </h3>
        {newRadiologyReports &&
          newRadiologyReports?.radiologyServiceInfo?.serviceDetails?.map(
            (item, index) => {
              const testData = item?._id
                ? testDataMap && (testDataMap[item?._id] || {})
                : {};
              return (
                <div key={index} className="mt-5">
                  <div className="d-flex align-items-center justify-content-between align-items-center gap-4">
                    <h4 className="">Name : {item?.serviceDetailsName}</h4>
                    <div className="d-flex align-items-center gap-4">
                      <div style={{ width: "15rem" }}>
                        {!selectAllOutsource &&
                          testData?.sourceType === "outSource" && (
                            <div className="form-group" key={item._id}>
                              <Select
                                name="outsourceLab"
                                placeholder="Select Lab"
                                value={{
                                  value: testData && testData?.labForOutsource,
                                  label:
                                    testData && testData?.labForOutsourceName,
                                }}
                                onChange={(e) =>
                                  handleTestProfileChange(
                                    e,
                                    "labForOutsource",
                                    item._id,
                                  )
                                }
                                options={
                                  allClinicLists &&
                                  allClinicLists?.map((item) => ({
                                    value: item._id,
                                    label: item?.clinicName,
                                  }))
                                }
                                styles={{
                                  menu: (provided) => ({
                                    ...provided,
                                    maxHeight: "14rem",
                                    overflowY: "auto",
                                  }),
                                }}
                              />
                            </div>
                          )}
                      </div>
                      <div className="d-flex align-items-center justify-content-end gap-3">
                        {sourceType?.map((status) => (
                          <div
                            key={`${status.value}_${item._id}`}
                            className="form-check custom-checkbox mb-3 ms-3 checkbox-info"
                          >
                            <input
                              type="radio"
                              className={classNames(
                                styles.checkbox,
                                "form-check-input",
                              )}
                              id={`${status.value}_${item._id}`}
                              name={`sourceType_${item._id}`}
                              value={status.value}
                              checked={
                                selectAllOutsource
                                  ? status.value === "outSource"
                                  : testData?.sourceType === status.value
                              }
                              onChange={(e) =>
                                handleSourceTypeChange(
                                  e,
                                  item._id,
                                  status.value,
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`${status.value}_${item._id}`}
                            >
                              {status.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <h5 className="mb-4 mt-2">Description :</h5>
                  <div className={styles["ckEditor"]} key={item._id}>
                    <CKEditor
                      editor={ClassicEditor}
                      data={testData?.description || ""}
                      onChange={(event, editor) =>
                        handleAddDescription(event, editor, item._id)
                      }
                    />
                  </div>
                </div>
              );
            },
          )}
      </div>
    </div>
  );
};

export default ServiceDetails;
